module.exports = __webpack_public_path__ + "img/logo_base.df7293fc.png";